export default __webpack_public_path__ + "static/media/add-to-queue.4b1bc851.svg";